export const CONTEXT_DRAWER_TABS = {
  PROFILE: 'profile',
  OVERVIEW: 'overview',
  LEAD: 'lead',
  NOTES: 'notes',
  AI: 'ai',
};

export const CONTEXT_DRAWER_TAB_LIST = [
  { id: CONTEXT_DRAWER_TABS.LEAD, label: 'Lead Details' },
  { id: CONTEXT_DRAWER_TABS.PROFILE, label: 'Profile' },
  { id: CONTEXT_DRAWER_TABS.OVERVIEW, label: 'Overview' },
  { id: CONTEXT_DRAWER_TABS.NOTES, label: 'Notes' },
  { id: CONTEXT_DRAWER_TABS.AI, label: 'AI Summary' },
];

export const DEFAULT_CONTEXT_DRAWER_TAB = CONTEXT_DRAWER_TABS.LEAD;

export function getContextDrawerTabPanelId(tabId) {
  return `intervene-context-tabpanel-${tabId}`;
}

export function getContextDrawerTabId(tabId) {
  return `intervene-context-tab-${tabId}`;
}
